<template>
  <v-dialog
      v-model="dialog"
      scrollable
      width="400"
  >
    <v-card>
      <v-card-title>Kataster auswählen</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="max-height: 300px;">
        <v-radio-group
            v-model="selected"
            column
            v-if="definitions.length > 0"
        >
          <v-radio v-for="definition in definitions"
              :key="definition.id"
              :label="definition.name"
              :value="definition.id"
          ></v-radio>

        </v-radio-group>
        <p v-else>Es ist noch kein Kataster angelegt.<br>Bitte wählen Sie <b>NEUANLAGE</b> um ein neues zu erstellen.</p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="success darken-1"
            text
            @click="dialog = false; $emit('select', 'new')"
        >
          Neuanlage
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="!selected"
            @click="dialog = false; $emit('select', selected)"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SelectDefinitionDialog",
  props: {
    definitions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      selected: null
    };
  },
  methods: {
    open() {
      this.selected = null;
      this.dialog = true;
    }
  },
}
</script>

<style scoped>

::v-deep .v-label {
  margin-bottom: 0px;
  font-size: 20px;
}

</style>
